import { gql } from '@apollo/client';

import {
  AddQuestionMessageDocument,
  type AddQuestionMessageMutation,
  type AddQuestionMessageMutationVariables,
} from '../__generated__/documents';

/**
 * The whole responder loop. One call answers the current question and returns
 * the backend's verdict on what happens next: a follow-up within the same
 * question, the next primary question, or the end of the survey. There is no
 * separate open or submit call — both folded into this one.
 *
 * `@unmask` on every spread: this mutation's response is read once, inline,
 * by `shared-responder-v2-gateway-gateway.ts` and converted to a plain turn
 * payload — no component ever re-subscribes to `UnifiedMessage`/
 * `UnifiedQuestion` through *this* response. Masking still strips `id` here
 * (the parent selects these fields only via the spread, never independently),
 * so `client.readFragment` cannot identify the entity to read it back —
 * `@unmask` is the correct fix, not a workaround.
 */
if (false) {
  gql`
    mutation AddQuestionMessage($input: AddQuestionMessageInput!) {
      addQuestionMessage(input: $input) {
        isQuestionComplete
        isConversationOver
        surveyProgress
        sent {
          ...UnifiedMessage @unmask
        }
        replyFeedback {
          ...UnifiedMessage @unmask
        }
        reply {
          ...UnifiedMessage @unmask
        }
        nextQuestion {
          ...UnifiedQuestion @unmask
        }
        thankYouMessage {
          ...UnifiedMessage @unmask
        }
        actions {
          preActivationActionType
          preActivationActionData
          postActivationActionType
          postActivationActionData
        }
      }
    }
  `;
}

export const ADD_QUESTION_MESSAGE = AddQuestionMessageDocument;
export type { AddQuestionMessageMutation, AddQuestionMessageMutationVariables };
